import {Content} from "#/src/pages/(auth)/register/Content";

export {Page}

function Page() {
  return <div className={"h-100"}><Content/></div>
}
